<template>

	<div class="color-selection">
	    <p class="h3 mb-2 pt-2 pb-4">Sélectionnez l'orientation de vos radiateurs</p>

	    <div class="row two-parts">
	      <div class="col-lg-7">
	        <ul class="list-unstyled">
	          <li>
	            <img class="w-100" :src="require('@/assets/img/radiateurs/'+the_image(this.state.selected_config.radiatorsFetched[0]))">
	          </li>
	        </ul>
	      </div>
	      <div class="col-lg-5 pl-md-4 pr-md-0">

	      	<div class="form-check check-base mb-4 pl-0" @click="selectOrientation('horizontal')">
	          <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios1" value="option1" :checked="state.radiator.orientation==='horizontal'">
	          <label class="form-check-label" for="exampleRadios1">
	          		<div class="radio-check"><i class="far fa-check"></i></div>
	             	<p class="mb-0 lead pt-1">Horizontal</p>
	          </label>
	        </div>

	        <div class="form-check check-base mb-4 pl-0" @click="selectOrientation('vertical')">
	          <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios2" value="option2" :checked="state.radiator.orientation==='vertical'">
	          <label class="form-check-label" for="exampleRadios2">
	          		<div class="radio-check"><i class="far fa-check"></i></div>
	             	<p class="mb-0 lead pt-1">Vertical</p>
	          </label>
	        </div>

	        <div class="alert alert-secondary rounded border-0 d-flex" role="alert">
	          <i class="far fa-info-circle mr-2 pt-1"></i> 
	          <span>Le choix de l'orientation est globale aux radiateurs
<!--              , mais vous pourrez la changer indépendamment à la fin de la configuration.-->
            </span>
	        </div>

	        <router-link :to="{name:'ColorSelection'}" class="btn btn-md btn-primary rounded-pill">
	          Étape suivante
	        </router-link>
	      </div>
      </div>
	</div>

</template>

<script>
export default {
  name: "OrientationSelection",
  methods:{
    selectOrientation(orientation){
      this.setDataRad('orientation',orientation)
      if (orientation=='horizontal')this.setDataRad('towelDryers','0')
      else this.setDataRad('towelDryers','2')
    }
  }
}
</script>

<style scoped>

</style>